export enum CardModifierType {
    bomb = 'bomb',
    ice = 'ice',
    lowering = 'lowering',
    rising = 'rising',
    pickaxe = 'water',
    rope = 'rope',
    fog = 'fog',
    card_reward = 'card_reward',
    connected = 'connected',
}
